import { Box, Typography } from "@mui/material";
import Head from "next/head";
import { useEffect } from "react";
import Breadcrumbs from "../../../src/components/common/Breadcrumbs";
import LoanFormPopupV2 from "../../../src/Drawer/LoanFormPopupV2";
import { MemoizedConnectDrawer } from "../../../src/Drawer/connectDrawer";
import FAQ from "../../../src/SDK/FAQ/faq";
import { OEMAdv } from "../../../src/constants/VehicleAdvantages";
import { oemVehicleContentData } from "../../../src/constants/VehiclesContent";
import { brandFAQs } from "../../../src/constants/brandFaqs";
import { blogData } from "../../../src/constants/oemBlogData";
import { oemPriceList } from "../../../src/constants/oemPriceInfo";
import { oemPromiseList } from "../../../src/constants/oemPromises";
import { primary } from "../../../src/constants/theme";
import { convertFAQsToQuestions, generateFAQPageSchema } from "../../../src/utils/FAQPageSchemaGenerator.js";
import {
  BrandLogos,
  newVehicles,
  vehicles,
} from "../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../src/constants/webpImages";
import { MemoizedFooter } from "../../../src/layouts/footer";
import { MemoizedHeader } from "../../../src/layouts/header";
import WhatsAppFloater from "../../../src/modules/Brand/WhatAppFloater";
import BookEVConsultationForm from "../../../src/modules/Home/BookEVconsult/bookEVConsultation";
import FullscreenDrawer from "../../../src/modules/Home/HomePageRevamp/VehicleSlideDrawer";
import QlDrawerComponent from "../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import MemoizedTopBanner from "../../../src/modules/Vehicles/Banner/BannerGeneric";
import BrandLogoTile from "../../../src/modules/Vehicles/Banner/BrandLogoTile";
import BulletPoints from "../../../src/modules/Vehicles/Banner/BulletPoints";
import HeaderDesc from "../../../src/modules/Vehicles/Banner/HeaderDesc";
import VehiclesAdv from "../../../src/modules/Vehicles/Banner/VehiclesAdv";
import MemoizedBrandBlogList from "../../../src/modules/Vehicles/BrandBlogList";
import MemoizedBrandDealerNear from "../../../src/modules/Vehicles/BrandDealerNear";
import MemoizedBrandPromises from "../../../src/modules/Vehicles/BrandPromises";
import MemoizedBrandVehicleLoan from "../../../src/modules/Vehicles/BrandVehicleLoan";
import MemoizedBrandVehicleVariant from "../../../src/modules/Vehicles/BrandVehicleVariant";
import { MemoizedBrandVehiclesListing } from "../../../src/modules/Vehicles/BrandVehicleslisting";
import MemoizedVehiclePriceList from "../../../src/modules/Vehicles/TableData/VehiclePriceList";
import MemoizedSearchHeader from "../../../src/modules/Vehicles/searchHeader";
import AtfContentSectionBrand from "../../../src/components/common/ContentTemplates/AtfContentSectionBrand";
import SeoContentSection from "../../../src/components/common/ContentTemplates/SeoContentSection";
import SeoContentRenderer from "../../../src/components/common/ContentTemplates/SeoContentRenderer";
import { sendAnalytics } from "../../../src/utils/analyticsCommon";
import { GAURANTEED_LOAN_EMI_CARD_DATA } from "../../../src/constants/electricCommericalVehicle/Eular/Eular.js";
import { generateBrandCollectionPageSchema } from "../../../src/utils/CollectionPageSchema.js";
import { generateItemListSchema, createListItem } from "../../../src/utils/ItemListSchema.js";
import {
  TITLE,
  META_CONTENT,
  VEHICLE_LINK,
  H1_HEADING,
  BRAND_HEADER_INFO,
  BRAND_DESCRIPTION,
  PRICE_LIST_HEADER,
  PRICE_LIST_DESCRIPTION,
  PROMISES_HEADER,
  ADVANTAGES_HEADING,
  ADVANTAGES_DESCRIPTION,
  HIGHLIGHTS_HEADING,
  HIGHLIGHTS_DESCRIPTION,
  BLOG_HEADER,
  ABOUT_HEADING,
  ABOUT_DESCRIPTION,
  MODELS_HEADER,
  MODELS_DESCRIPTION,
  DEALER_HEADER,
  DEALER_DESCRIPTION,
  FAQ_HEADING,
  LOAN_HEADER,
  CTA_TEXT,
  CONNECT_HEADING,
  CONNECT_SUBHEADING,
  CONNECT_CTA_TEXT,
  AVAILABLE_BRANDS_TITLE,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
  ATF_CONTENT,
  ATF_NOTE,
  ATF_TABLE_HEADING,
  ATF_TABLE_COLUMNS,
  ATF_TABLE_DATA,
  SEO_FOOTER_CONTENT,
} from "../../../src/constants/electricCommericalVehicle/Etrio/index.js";

export default function VehicleBrand({ brand, BrandVehiclesData, BrandLogos, collectionPageSchema, itemListSchema, faqPageSchema }) {
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}` },
      "en"
    );
  }, [brand]);

  //We need to add SEO Meta info later

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={VEHICLE_LINK} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(collectionPageSchema),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(itemListSchema),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqPageSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>

      <body>
        <Box>
          {/* Main component */}
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <MemoizedHeader />
          </Box>
          <FullscreenDrawer />
          <LoanFormPopupV2 />
          <QlDrawerComponent />
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <MemoizedSearchHeader isProductPage={true} />
          </Box>
          <MemoizedTopBanner
            bannerData={{
              desktopImg: imagesWEBP?.Etrio?.etrioDesktopBanner,
              mobileImg: imagesWEBP?.etrioBanner,
              alt: "ETrio electric auto banner",
            }}
          />
          <Box sx={{ display: { sm: "block", md: "none", lg: "none" } }}>
            {" "}
            <BookEVConsultationForm />
          </Box>
          <Box
            sx={{
              display: { sm: "block", md: "none", lg: "none" },
              margin: "15px",
            }}
          >
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/QrOm4ZOKJNk?si=FEyYeJ7hSxUOZOSA"
              title="YouTube video player"
              frameborder="0"
              style={{ borderRadius: "10px" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </Box>

          <Typography
            variant="h1"
            style={{ fontSize: "34px", fontWeight: 700, paddingLeft: "8%" }}
          >
            {H1_HEADING}
          </Typography>

          <AtfContentSectionBrand
            content={ATF_CONTENT}
            tableData={{
              type: "pricing",
              heading: ATF_TABLE_HEADING,
              columns: ATF_TABLE_COLUMNS,
              data: ATF_TABLE_DATA,
            }}
            note={ATF_NOTE}
          />

          <MemoizedBrandVehiclesListing
            vehicleLocalData={BrandVehiclesData}
            ctaText={CTA_TEXT}
          />
          {/* <MemoizedVehiclePriceList
            priceData={{
              priceList: oemPriceList?.etrio,
              headerInfo: PRICE_LIST_HEADER,
              description: PRICE_LIST_DESCRIPTION,
            }}
          /> */}
          <MemoizedBrandPromises
            promisesData={{
              headerInfo: PROMISES_HEADER,
              promiseList: oemPromiseList?.etrio,
            }}
          />

          <BrandLogoTile
            BrandLogos={BrandLogos}
            brand={brand}
            title={AVAILABLE_BRANDS_TITLE}
          />

          <HeaderDesc
            HeadingTag="h2"
            heading={ADVANTAGES_HEADING}
            subText={ADVANTAGES_DESCRIPTION}
          />
          <VehiclesAdv listItems={OEMAdv?.etrio} />
          <MemoizedBrandVehicleLoan headerInfo={LOAN_HEADER} cardDetails={GAURANTEED_LOAN_EMI_CARD_DATA} />

          <HeaderDesc
            HeadingTag="h2"
            heading={HIGHLIGHTS_HEADING}
            subText={HIGHLIGHTS_DESCRIPTION}
          />

          <MemoizedBrandBlogList
            blogData={{
              data: blogData?.etrio,
              headerInfo: BLOG_HEADER,
            }}
          />

          {/* <HeaderDesc
            heading={ABOUT_HEADING}
            subText={ABOUT_DESCRIPTION}
          /> */}
          <BulletPoints ContentData={oemVehicleContentData?.etrio?.USPs} />

          <MemoizedBrandVehicleVariant
            brandVariantData={{
              headerInfo: MODELS_HEADER,
              description: MODELS_DESCRIPTION,
              variantList: oemPriceList?.etrio,
            }}
          />
          {/* <BulletPoints ContentData={oemVehicleContentData?.etrio?.Insights} /> */}

          <MemoizedBrandDealerNear
            BannerDealerData={{
              headerInfo: DEALER_HEADER,
              description: DEALER_DESCRIPTION,
              desktopImg: imagesWEBP?.locationBanner,
              mobileImg: imagesWEBP?.locationBanner,
            }}
          />

          <SeoContentSection>
            <SeoContentRenderer content={SEO_FOOTER_CONTENT} />
          </SeoContentSection>

          <Box
            style={{
              // display: "flex",
              // alignItems: "center",
              justifyContent: "center",
              paddingTop: "20px",
              padding: "20px 8% 20px 8%",

              width: "100% !important",
              background: primary?.lightGrey,
            }}
          >
            <FAQ
              faqList={brandFAQs?.etrio}
              showItems={brandFAQs?.etrio?.length}
              headText={FAQ_HEADING}
            />
          </Box>
          <WhatsAppFloater />
          <MemoizedConnectDrawer
            heading={CONNECT_HEADING}
            subHeading={CONNECT_SUBHEADING}
            ctaText={CONNECT_CTA_TEXT}
          />
          <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
            <Breadcrumbs items={BREADCRUMB_ITEMS} />
          </Box>
          <MemoizedFooter />
        </Box>
      </body>
    </>
  );
}

export const getStaticProps = (context) => {
  const brand = "Etrio";
  let allvehicles = [...vehicles, ...newVehicles];
  let BrandVehiclesData = allvehicles?.filter((vehicle) => {
    return vehicle?.brand?.toLocaleLowerCase() === brand?.toLocaleLowerCase();
  });

  // Generate CollectionPage Schema
  const collectionPageSchema = generateBrandCollectionPageSchema({
    title: TITLE,
    url: VEHICLE_LINK,
    description: META_CONTENT[0]?.content,
    headline: H1_HEADING,
    keywords: META_CONTENT[1]?.content || `${brand} electric vehicles`,
    breadcrumbSchema: BREADCRUMB_SCHEMA,
    primaryImageUrl: imagesWEBP?.Etrio?.etrioDesktopBanner,
    brandName: brand,
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
  });

  // Generate ItemList Schema
  const itemListSchema = generateItemListSchema({
    name: `${brand} Electric Vehicles`,
    description: `List of ${brand} electric commercial vehicles available at Turno`,
    itemListElement: BrandVehiclesData.map((vehicle, index) => {
      const vehicleUrl = vehicle.vehicle_path_id 
        ? `https://www.turno.club/electric-commercial-vehicles/${brand}/${vehicle.vehicle_path_id}`
        : `https://www.turno.club/electric-commercial-vehicles/${brand}`;
      
      return createListItem({
        position: index + 1,
        name: vehicle.name || vehicle.vehicle_name || `${brand} ${vehicle.vehicle_path_id}`,
        url: vehicleUrl,
        description: vehicle.meta_description || vehicle.page_title || `${brand} ${vehicle.vehicle_name || vehicle.vehicle_path_id} electric vehicle`,
        image: vehicle.image || vehicle.storeImage || vehicle.homeImage,
      });
    }),
    itemListOrder: "Ascending",
    numberOfItems: BrandVehiclesData.length,
    url: VEHICLE_LINK,
  });

  // Generate FAQPage Schema from brandFAQs.etrio
  const faqQuestions = convertFAQsToQuestions(brandFAQs?.etrio || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: FAQ_HEADING || "FAQs on Etrio Electric Vehicles",
    description: `Frequently asked questions about Etrio electric commercial vehicles.`,
    url: VEHICLE_LINK,
    headline: FAQ_HEADING || "FAQs on Etrio Electric Vehicles",
    keywords: META_CONTENT[0]?.content || "Etrio, FAQ, electric commercial vehicle",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: imagesWEBP?.Etrio?.etrioDesktopBanner || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
  });

  return {
    props: { 
      brand, 
      BrandVehiclesData, 
      BrandLogos,
      collectionPageSchema,
      itemListSchema,
      faqPageSchema,
    },
  };
};
